'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      typography = _baseTheme$vstui.typography,
      zIndex = _baseTheme$vstui.zIndex;
  return (0, _themes.createComponentTheme)(baseTheme, {
    Tooltip_backgroundColor: color.ninja.getShade(10),
    Tooltip_color: color.white,
    Tooltip_fontFamily: typography.fontFamily,
    Tooltip_fontSize: typography.pxToRem(typography.fontSize - 2),
    Tooltip_fontWeight: typography.fontWeightRegular,
    Tooltip_transitionDuration: '150ms',
    Tooltip_transitionEasing: 'cubic-bezier(0.7, 0, 0.7, 1)',
    Tooltip_zIndex: zIndex.tooltip
  });
};

exports.default = componentTheme;